<template>
    <public-ask-for-quote-layout>
        <Head>
            <title>Login</title>
        </Head>
        <div class="public-ask-for-quote">
            <Stepper>
                <step icon="list-basket-checkmark" class-names="active current">
                    <translate>Bauteilinformationen</translate>
                </step>
                <step icon="lock-shield-prote" />
                <step icon="delivery-shipment-packages-setting" />
                <step icon="credit-card-security-protection" />
            </Stepper>
            <div class="public-ask-for-quote--form">
                <h1 class="h4" v-translate>Erstellen Sie jetzt Ihre erste Fertigungsanfrage</h1>
                <form @submit.prevent="submit">
                    <card class="card--minify card--message error " v-if="form.errors.account">
                        <card-content v-html="form.errors.account"></card-content>
                    </card>
                    <form-drop-zone field="sketch_file" maxFilesize="2" fileType=".pdf"
                                    maxFiles="1"
                                    uploadTarget="public-ask-for-quote.1.upload"
                                    deleteTarget="public-ask-for-quote.1.delete"
                                    :current-file="form.ask_for_quotes[0]?.sketch_file"
                                    :error="form.errors[`ask_for_quotes.0.sketch_file`]"
                                    :ask-for-quote-index="0"
                                    @acceptFiles="form.errors[`ask_for_quotes.0.sketch_file`] = null;">
                        <template v-slot:label>
                            <translate>Zeichnung</translate>
                        </template>
                        <template v-slot:textDrag>
                            <translate render-html="true">Legen Sie die PDF-Dateien hier
                                ab<br/>&nbsp;
                            </translate>
                        </template>
                        <template v-slot:textReplace>
                            <translate render-html="true">Legen Sie die PDF-Dateien hier ab
                                um
                                die
                                bestehende zu ersetzen<br/>&nbsp;
                            </translate>

                        </template>
                        <template v-slot:textdefault>
                            <translate render-html="true">Hochzuladende PDF-Dateien hierhin
                                ziehen<br/>
                                oder nach Dateien suchen (max. 2MB)
                            </translate>
                        </template>
                    </form-drop-zone>

                    <form-group>
                        <form-input type="text" id="lotqty_1"
                                    :label="this.$gettext('Stückzahl')"
                                    v-model="form.ask_for_quotes[0].lotqty_1"
                                    placeholder="10"
                                    :error="form.errors[`ask_for_quotes.0.lotqty_1`]" autocomplete="off" class="one-four"/>
                        <form-input type="email" id="email" :label="this.$gettext('Email Adresse')" v-model="form.email"
                                    placeholder="john@doe.com" :error="form.errors.email" icon="email-mail-checkmark"
                                    autocomplete="email" class="three-four"/>
                    </form-group>

                    <div class="form-actions">
                        <form-button type="submit" color="secondary" icon="button-arrow-right-circle" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                            <translate>weiter</translate>
                        </form-button>
                    </div>
                </form>
            </div>
            <div class="public-ask-for-quote--info">
                <p class="body-2 body-2--disabled">
                    <translate render-html="true">Es können ausschließlich <strong>registrierte Geschäftskunden</strong> beliefert werden.
                        An Privatpersonen liefern wir nicht aus! Ihre Daten werden nur für Ihre Anfragen und Aufträge
                        genutzt, nicht an Dritte weitergeleitet, nicht für Werbezwecke verwendet. Das garantieren wir Ihnen.
                        Ihre Kundendaten handhaben wir streng vertraulich, gemäß den Datenschutzbestimmungen der
                        Bundesrepublik Deutschland.
                    </translate>
                </p>
            </div>
        </div>
    </public-ask-for-quote-layout>
</template>

<script>
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormButton from '@partfactory/Shared/Form/FormButton';
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';
import PublicAskForQuoteLayout from '@partfactory/Layouts/PublicAskForQuoteLayout.vue';
import Stepper from '@partfactory/Shared/Stepper/Stepper.vue';
import Step from '@partfactory/Shared/Stepper/Step.vue';
import FormDropZone from '@partfactory/Shared/Form/FormDropZone.vue';
import FormGroup from '@partfactory/Shared/Form/FormGroup.vue';

export default {
    name: 'PublicAskForQuote1',
    components: {
        FormGroup,
        FormDropZone,
        Step,
        Stepper,
        Card,
        CardContent,
        FormButton,
        FormInput,
        PublicAskForQuoteLayout,
    },
    props: {
        askForQuotes: Object,
        sketchFiles: Object,
    },
    data() {
        let askForQuotesProxy = this.askForQuotes;
        let sketchFilesProxy = this.sketchFiles ? this.sketchFiles : {};

        const form = useForm({
            ask_for_quotes: [],
            email: null,
        });
        form.ask_for_quotes.push({
            lotqty_1: this.askForQuotes?.[0]?.lotqty_1,
            sketch_file: this.sketchFiles?.[0] ? this.sketchFiles?.[0] : null,
        });

        return {form, askForQuotesProxy, sketchFilesProxy};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('public-ask-for-quote.1.post'), {
                    onSuccess: () => {
                        // Anfrage-Formular abgeschickt (Schritt 0)
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'form_send',
                            'formName': 'Anfrage',
                            'formStep': '0 - Anfrage einstellen, öffentliche Anfrageseite',
                            'formLang': this.$language.current,
                        });
                    }
                });
        }
    },
};
</script>
